import React from 'react';
import { useThemeColors } from '../hooks/useTheme';
import '../assets/styles/_variables.scss';
import Header from '../components/Header/Header';
import About from '../components/About/About';
import Contact from '../components/Contact/Contact';
import Education from '../components/Education/Education';
import Experience from '../components/Experience/Experience';
import Footer from '../components/Footer/Footer';
import Home from '../components/Home/Home';
import Projects from '../components/Projects/Projects';
import Map from '../components/Map/Map';

const MainPage: React.FC = () => {
  const colors = useThemeColors();

  return (
    <div style={{ 
      backgroundColor: colors.background,
      color: colors.primary,
      minHeight: '100vh',
      transition: 'background-color 0.3s, color 0.3s'
    }}>
      <Header />
      <main>
        <Home />
        <About />
        <Experience />
        <Education />
        <Projects />
        <Contact />
        <Map />
      </main>
      <Footer />
    </div>
  );
};

export default MainPage;